/* eslint-disable no-param-reassign */
import { IPageContent } from "api/interfaces/static-content.type";
import PAText from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import QS from "query-string";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { b2bUrl } from "util/url/static-urls";
import useSafeRouter from "../../hoc/useSafeRouter";
import { deepFind } from "../../util/helper/deepFind";
import { capitalize } from "../../util/lodash/capitalize";
import {
  PRODUCT_PAGE_TYPES, TIER_MAKE_MODEL_PAGES, TIER_MAKE_PAGES, TIER_PAGES,
} from "../../util/product/product-constants";
import BreadcrumLi from "./BreadcrumLi";
import styles from "./mak-model-year.module.scss";

interface IProps {
  staticContent: IPageContent;
}

function BreadcrumbCompact(props: IProps) {
  const {
    breadCrumbsV2 = [], staticContent, bannerData, className, category = {}, showBackToResult = false,
  } = props;
  const router = useRouter();
  const pageType = useSelector((state: RootState) => state.utils.currentPageType);
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);

  const { query } = useSafeRouter();
  const { t } = useTranslation("common");
  const {
    pathname, tier1, tier2, tier3,
  } = query;
  const { pageDetails = {} } = staticContent || {};
  const pageDisplayableTitle = deepFind(pageDetails, "pageDisplayableTitle", bannerData?.categoryDisplayableTitle);

  const getBreadcrumbList = () => {
    const singleBredCRumList = breadCrumbsV2[0] || [];
    let currentPageBreadcrum;
    let filtersBreadCrums: any = [];
    if (pageDisplayableTitle) {
      currentPageBreadcrum = { title: pageDisplayableTitle, url: `/${pathname}` };
      filtersBreadCrums = [tier1, tier2, tier3]
        .filter(Boolean)
        .map((_) => ({
          title: capitalize(_),
          url: `/${pathname}?${QS.stringify({
            tier1: query.tier1,
            tier2: query.tier2,
            // we don't add T3 since, remove URL from last item
            // tier3: index <= 2 ? query.tier3 : undefined,
          })}`,
        }));
    }

    const breadCrumbList = [
      { title: t("Home"), url: businessCustomer ? b2bUrl : "/", href: businessCustomer ? b2bUrl : "/" },
      ...singleBredCRumList,
      currentPageBreadcrum,
      ...filtersBreadCrums,
    ].filter(Boolean);

    if (PRODUCT_PAGE_TYPES.includes(pageType)) {
      breadCrumbList.push({ title: t("Product Details") });
    }

    return breadCrumbList;
  };

  const [itemListElement, setItemListElement] = useState(getBreadcrumbList());

  useEffect(() => {
    setItemListElement(getBreadcrumbList());
  }, [pageDisplayableTitle, tier1, tier2, tier3, pageType]);

  return (
    <div className={`${styles.breadcrumb} ${className}`}>

      <nav>

        <ol>
          {showBackToResult && (
            <PAText component="span" onClick={router.back} className={styles.back_button}>
              <ArrowLeft size={14} strokeWidth={5} color="#31b0d5" />
              &nbsp;
              {t("Back to Results")}
            </PAText>
          )}
          {
            itemListElement
              .map((item, index) => {
                const categoryObj = { tier0: category.tier0, tier1: category.tier1, tier2: category.tier2 };
                if (item?.pageType?.includes(TIER_PAGES[3], TIER_MAKE_PAGES[2], TIER_MAKE_MODEL_PAGES[3])) {
                  categoryObj.tier3 = category.tier3;
                }
                return (
                  <BreadcrumLi
                    key={item.title}
                    isLast={index === itemListElement.length - 1}
                    {...item}
                    categoryObj={categoryObj}
                    index={index}
                  />
                );
              })
          }
        </ol>
      </nav>
    </div>
  );
}

export default BreadcrumbCompact;
